"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.databaseRowWindowPreload = databaseRowWindowPreload;
exports.databaseRowWindow = databaseRowWindow;
/**
 * Height drawn beyond each edge of a viewport of `viewportHeight`, so rows
 * stand ready before they scroll in. Self-contained like databaseRowWindow.
 */
function databaseRowWindowPreload(viewportHeight) {
    return Math.max(600, viewportHeight * 2);
}
function databaseRowWindow(rowCount, baseHeight, measured) {
    const deltas = new Map();
    for (const [index, height] of measured)
        if (index >= 0 && index < rowCount && height !== baseHeight)
            deltas.set(index, height - baseHeight);
    const overrideIndexes = [...deltas.keys()].sort((a, b) => a - b);
    const prefixDeltas = [];
    let total = 0;
    for (const index of overrideIndexes) {
        total += deltas.get(index) ?? 0;
        prefixDeltas.push(total);
    }
    /** Sum of the deltas of the rows before `index`. */
    const deltaBefore = (index) => {
        let low = 0;
        let high = overrideIndexes.length;
        while (low < high) {
            const mid = (low + high) >> 1;
            if ((overrideIndexes[mid] ?? Number.POSITIVE_INFINITY) < index)
                low = mid + 1;
            else
                high = mid;
        }
        return low === 0 ? 0 : (prefixDeltas[low - 1] ?? 0);
    };
    const heightAt = (index) => baseHeight + (deltas.get(index) ?? 0);
    const topAt = (index) => index * baseHeight + deltaBefore(index);
    return {
        rowCount,
        baseHeight,
        height: rowCount * baseHeight + total,
        heightAt,
        topAt,
        range(top, bottom) {
            let low = 0;
            let high = rowCount;
            while (low < high) {
                const mid = (low + high) >> 1;
                if (topAt(mid) + heightAt(mid) < top)
                    low = mid + 1;
                else
                    high = mid;
            }
            let end = low;
            while (end < rowCount && topAt(end) <= bottom)
                end++;
            return { first: low, end };
        },
    };
}
